import { createSelector } from 'reselect';

import { selectSubCompany } from './subCompany.selectors';

export const selectSubCompanyChannels = createSelector(
  selectSubCompany,
  subCompany => subCompany?.channels || [],
);
